import { addDays } from 'date-fns/addDays';
import { isAfter } from 'date-fns/isAfter';
import { ProductStatusConstant, ProductStatusType } from '../../constants/product/product.constant';

export const isNewProduct = (startOnSaleDate: Date, status: ProductStatusType): boolean => {
  if (!startOnSaleDate || status !== ProductStatusConstant.ONSALE) {
    return false;
  }
  return isWithinNewProductPeriod(startOnSaleDate);
};

export const isWithinNewProductPeriod = (startOnSaleDate: Date): boolean => {
  const endDateForNewProduct = addDays(startOnSaleDate, 7);
  const today = new Date();
  return isAfter(endDateForNewProduct, today);
};
